// extracted by mini-css-extract-plugin
export default {"sectionRow":"sectionRow-Wh7At","arrowIconRight":"arrowIconRight-fbU41","sectionTitle":"sectionTitle-ymzXs","line":"line-oV2D6"};